<div *ngIf="ready">

    <div class="flex flex-col md:flex-row justify-between items-center h-max">
        <h2 class="md:mr-4">Anagrafiche</h2>

        <div class="flex justify-center md:justify-end w-full md:-mt-10 relative">
            <div *ngIf="showMsg" @slideDownUp
                class="button-container transition-all duration-300 ease-in-out w-full z-40 absolute">
                <button
                    class="w-full shadow-lg hover:shadow-xl hover:shadow-emerald-300 p-3 bg-emerald-300/60 text-emerald-800 rounded-full flex gap-2 justify-center float-right transition-all duration-300 ease-in-out items-center cursor-pointer hover:text-white hover:bg-emerald-500/50">
                    <div class="whitespace-nowrap">{{message}}</div>
                </button>
            </div>

            <div *ngIf="!showMsg" @slideDownUpLeave
                class="button-container transition-all duration-300 ease-in-out w-fit z-0 absolute">
                <button (click)="saveSettings()"
                    class="w-fit shadow-lg hover:shadow-xl hover:shadow-emerald-300 p-3 bg-emerald-300/60 text-emerald-800 rounded-full flex gap-2 justify-center float-right transition-all duration-300 ease-in-out items-center cursor-pointer hover:text-white hover:bg-emerald-500/50">
                    <div>{{'Salva'}}</div>
                </button>
            </div>
        </div>


    </div>

    <h3 class="md:mt-8 mt-12">Clienti</h3>

    <div class="card-primary flex flex-col items-center justify-between">

        <div class="flex justify-between gap-2  rounded-xl items-center w-full">
            <div class="text-xl font-semibold">Consenti aggiunta di clienti con partita iva esistente</div>

            <div>

                <!--CUSTOM SWITCH i know should be a core component-->

                <label class="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" [(ngModel)]="anagraficheViewSwitchState" class="sr-only peer"
                        (click)="switchClick()">
                    <div class="group peer ring-0 bg-slate-400  rounded-full outline-none duration-300 after:duration-300 w-16 h-8  shadow-md peer-checked:bg-primary-700 
                        peer-focus:outline-none  after:content-['']  after:rounded-full after:absolute after:bg-gray-50 after:outline-none after:h-8 after:w-8 after:top-0
                        after:left-0 after:flex after:justify-center after:items-center peer-checked:after:translate-x-8 peer-checked:after:content-[''] 
                        peer-hover:after:scale-75">
                    </div>

                </label>

            </div>
        </div>


        <div class="grid grid-cols-1 md:grid-cols-10 mt-2 w-full">
            <div class="col-span-1 md:col-span-6 flex flex-col">
                <span>Se l'opzione è attiva, il sistema consentirà di inserire più clienti con la stessa partita iva.</span>
                <span>Quando l'opzione è disattiva, il sistema bloccherà l'inserimento del cliente se la partita iva corrisponde ad un cliente già esistente.</span>
                <span class="font-bold">NOTA: l'opzione si applica a tutti gli utenti</span>
            </div>            
            
        </div>

    </div>

</div>